import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CustomCurrencyPipe } from '../../../shared/pipes/custom-currency.pipe';
import { Promotion } from '../../../types/promotion.type';

@Component({
  selector: 'app-promo-details',
  templateUrl: './promo-details.component.html',
  styleUrls: ['./promo-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, CustomCurrencyPipe],
})
export class PromoDetailsComponent {
  @Input() promo: Promotion;
}
